// test1181
(1181 && 0);
